import React from "react";

import { BarChart } from "@mui/x-charts/BarChart";

import { ColumnConfig } from "../../definitions";
import { useIndicators } from "../../hooks/useIndicators";
import { useWidgetFetch } from "../../hooks/useWidgetFetch";
import { formatValues } from "../../utils";
import { RendererProps } from "./types";

export const BarWidget = (props: RendererProps) => {
  const { data, colNames, isLoading, error } = useWidgetFetch(
    props.config.title,
    props.config.dataSource,
    props.optionValues,
  );

  const { config } = props;

  const someIndicatorView = useIndicators(props, isLoading, error);
  if (someIndicatorView) {
    return someIndicatorView;
  }

  const cols = config.columns || colNames.map(name => ({ name, type: "string" }) as ColumnConfig) || [];
  const { colors, stack } = config.options;

  const nSeries = data[0] ? Object.keys(data[0]).length - 1 : 0;

  const seriesData = new Array(nSeries).fill({}).map((_, index) => ({
    data: data.map((item: any) => item[index + 1]),
    label: nSeries > 1 ? cols[index]?.name || `Series ${index + 1}` : undefined,
    stack,
  }));

  return (
    <BarChart
      colors={colors || props.colors}
      yAxis={[
        {
          id: "linearAxis",
          scaleType: "linear",
          position: "left",
          valueFormatter: (value: any) => formatValues(value, cols[0]),
        },
      ]}
      xAxis={[
        {
          scaleType: "band",
          data: data.map((item: any) => item[0]),
        },
      ]}
      series={seriesData}
      height={400}
      slotProps={{
        legend: {
          direction: "row",
          position: { vertical: "top", horizontal: "right" },
          padding: 0,
        },
      }}
    />
  );
};
